import { useQuery } from "@apollo/react-hooks"
import HtmlParser from "react-html-parser"
import { useEffect } from "react"
import { imagesOfType, CATEGORY_SELECTION } from "lacinetek-common/src/images"
import { SVOD_BLOCK_TEXT, metadata } from "lacinetek-common/src/metadata"

import { FETCH_SVOD_OFFERS } from "lib/graphql"
import { useTranslation } from "lib/i18n/translation"
import { useCountry } from "lib/country"
import { useModal } from "lib/modal"
import { useLanguages } from "lib/languages"
import { useCart } from "lib/cart"
import { isSubscriptionOffer } from "tools/subscription"

import SkeletonLink from "components/common/skeleton-link"
import Image from "components/common/image"
import { FooterOffer } from "components/subscription/footer-offer"
import { BlockOfferLacinetek } from "components/subscription/block-offer-lacinetek"
import { BlockSpecialRate } from "components/subscription/block-special-rate"
import OfferCinepassForm from "components/modals/offer-cinepass-form"
import { NavOffers } from "components/offers/nav-offers"

import TicketInfinite from "static/assets/icons/ticket_infinite.svg"
import Ticket48H from "static/assets/icons/ticket_48h.svg"
import CinepassBig from "static/assets/icons/cinepass_big.svg"

const FylmByFilm = () => {
	const { c } = useTranslation()
	const { show, hide } = useModal()
	const { current } = useLanguages()
	const { country: { isoCode } } = useCountry()
	const { getPrepayments } = useCart()
	const { data, loading, error, refetch } = useQuery(FETCH_SVOD_OFFERS, {
		variables: {
			query: `nos-offres-${isoCode}`
		}
	})

	useEffect(() => {
		getPrepayments()
	}, [])

	useEffect(() => {
		refetch()
	}, [current])

	if (loading) {
		return (
			<div className="is-loading centered" />
		)
	}

	const { children: { items: offers } } = data.cms.categories.items[0]
	const singleOffers = offers.find(offer => !isSubscriptionOffer(offer))

	const chooseCinepass = () => {
		hide(() => {
			show({
				id: "offer-modal",
				className: "modal tvod-color",
				children: <OfferCinepassForm />
			})
		})
	}
	const bannerImg = imagesOfType(singleOffers, CATEGORY_SELECTION)[0]

	return (
		<>
			{
				!!bannerImg
				&& <section className="focus full no-fx">
					<figure className="cover full">
						<picture>
							<Image
								src={bannerImg}
								alt={singleOffers.descriptionShort}
							/>
						</picture>
					</figure>
				</section>
			}
			<section className="tvod-color">
				<NavOffers />
				<h1 className="main-title">{c("lacinetek-film-by-film")}</h1>
				<p>{c("single-description")}</p>
				<div className="offers blocks full">
					<div className="item full">
						<div className="item-content">
							<figure>
								<Ticket48H title={c("tickets-fourty-eight-hour-icon-title")} />
							</figure>
							<div className="infos">
								<h3 className="title">{c("tickets-fourty-eight-hour-infos")}</h3>
								<p className="price">{HtmlParser(c("tickets-fourty-eight-hour-price"))}</p>
							</div>
							<SkeletonLink href="/films">
								<a
									title={c("choose-a-film")}
									className="button full"
								>
									{c("choose-a-film")}
								</a>
							</SkeletonLink>
							<div className="description">
								<p>{c("tickets-fourty-eight-hour-description")}</p>
							</div>
						</div>
					</div>
					<div className="item full">
						<div className="item-content">
							<figure>
								<TicketInfinite title={c("tickets-infinite-icon-title")} />
							</figure>
							<div className="infos">
								<h3 className="title">{c("tickets-infinite-infos")}</h3>
								<p className="price">{HtmlParser(c("tickets-infinite-price"))}</p>
							</div>
							<SkeletonLink href="/films">
								<a
									title={c("choose-a-film")}
									className="button full"
								>
									{c("choose-a-film")}
								</a>
							</SkeletonLink>
							<div className="description" dangerouslySetInnerHTML={{ __html: c("tickets-infinite-description") }} />
						</div>
					</div>
				</div>
				<div className="offers blocks">
					<div className="item">
						<div className="item-content">
							<div className="inline">
								<figure className="small">
									<CinepassBig title={c("pm_cinepass")} />
								</figure>
								<div className="infos">
									<h3 className="title">{c("cinepass-big-infos")}</h3>
									<p className="price">{HtmlParser(c("cinepass-big-price"))}</p>
								</div>
								{/* <div className="description" dangerouslySetInnerHTML={{ __html: c("cinepass-big-description")}} /> */}
							</div>
							<a
								href="#"
								onClick={e => { e.preventDefault(); chooseCinepass() }}
								rel="nofollow noopener"
								title={c("choose-a-cinepass")}
								className="button full"
							>
								{c("choose-a-cinepass")}
							</a>
						</div>
					</div>
					<BlockOfferLacinetek />
					<BlockSpecialRate />
				</div>
				<FooterOffer />
			</section>
		</>
	)
}

export default FylmByFilm
